class CountDown extends HTMLElement {
	MILLISECONDS_IN_DAY = 1000 * 60 * 60 * 24;
	MILLISECONDS_IN_HOUR = 1000 * 60 * 60;
	MILLISECONDS_IN_MINUTE = 1000 * 60;
	MILLISECONDS_IN_SECOND = 1000;
	DAYS = ' Tage';
	HOURS = ' Stunden';
	MINUTES = ' Minuten';
	SECONDS = ' Sekunden';

	FIRST_INTERVAL_STRING = 'DIE BESTEN ANGEBOTE ENDEN IN';
	SECOND_INTERVAL_STRING = 'DER BLACK DEAL ENDET IN';
	constructor() {
		super();
		// return;
		// Start in 20 min and ends in 1 hour
		// Start november 20 2024 16:30:00 and ends november 20 2024 17:30:00
		try {
			this.startDate = this.getAttribute('start-date') || new Date();
			this.countDownResult = this.querySelector('[countdown-result]');
			this.preString = this.querySelector('[pre-string]');
			this.ticker = Array.from(this.querySelectorAll('[ticker-type]'));
			this.firstIntervalUrl = this.getAttribute('url-1');
			this.secondIntervalUrl = this.getAttribute('url-2');
			this.first_interval_message = this.getAttribute('message-1') || this.FIRST_INTERVAL_STRING;
			this.second_interval_message = this.getAttribute('message-2') || this.SECOND_INTERVAL_STRING;
			this.pre_message = this.getAttribute('pre-message') || 'Counter will start in';

			// one hour from now
			this.firstIntervalEndDate = this.getAttribute('end-interval-1') || new Date('2024-11-20T16:30:00');

			// this.firstIntervalStartDate = ;
			this.secondIntervalEndDate =
				this.getAttribute('end-date') || new Date(this.firstIntervalEndDate.getTime() + 3 * 60 * 1000);

			this.mainParentContainer = this.closest('.count-down');

			this.siteHeader = document.querySelector('.site-header');
			// header-fixed-height
			this.siteHeaderHeight = document.querySelector('.header-fixed-height');
			this.initHeightOfSiteHeader = this.siteHeaderHeight.clientHeight;
			// announcement-bar-fixed
			this.announcementBar = document.querySelector('.announcement-bar-fixed');
		} catch (error) {
			console.log(error);
		}
	}
	connectedCallback() {
		this.init();
		if (this.isDaysInHours) {
			this.daysTicker.classList.add('hidden');
		}
	}

	handleSiteHeaderMarginTop() {
		const style = this.siteHeader.currentStyle || window.getComputedStyle(this.siteHeader);
		const currentMarginTop = parseInt(style.marginTop);
		this.siteHeader.style.marginTop = currentMarginTop + this.mainParentContainer.clientHeight + 'px';
		const announcementBarHeight = this.announcementBar.clientHeight;
		this.siteHeaderHeight.style.height = announcementBarHeight + 'px';
	}

	init() {
		this.setIntervalTimer();
	}

	_setUrl(url) {
		this.countDownResult.href = url;
	}

	setIntervalTimer() {
		this.interval = setInterval(() => {
			this.updateTimer();
		}, 1000);
	}

	get daysTicker() {
		return this.ticker.find((ticker) => ticker.getAttribute('ticker-type') === 'days');
	}

	get hoursTicker() {
		return this.ticker.find((ticker) => ticker.getAttribute('ticker-type') === 'hours');
	}

	get minutesTicker() {
		return this.ticker.find((ticker) => ticker.getAttribute('ticker-type') === 'minutes');
	}

	get secondsTicker() {
		return this.ticker.find((ticker) => ticker.getAttribute('ticker-type') === 'seconds');
	}

	get _initialized() {
		return this.getAttribute('_initialized') === 'true';
	}

	get isDaysInHours() {
		return this.getAttribute('days-in-hours') === 'true';
	}

	convertTime(time) {
		return time.toString().padStart(2, '0');
	}

	setTimeAndText(element, time, text) {
		const daysElement = element.querySelector('.ticker-time');
		const textElement = element.querySelector('.ticker-text');
		daysElement.innerHTML = time;
		textElement.innerHTML = text;
		if (time === '00') {
			daysElement.parentElement.classList.add('hidden');
		}
	}

	setTime(preString, diff) {
		this.preString.innerHTML = preString.replace(/&([^&]*)&/g, '<u>$1</u>');

		// this.daysTicker.innerHTML = this.convertTime(Math.floor(diff / this.MILLISECONDS_IN_DAY));
		if (!this.isDaysInHours) {
			debugger;
			this.setTimeAndText(this.daysTicker, this.convertTime(Math.floor(diff / this.MILLISECONDS_IN_DAY)), this.DAYS);
			this.setTimeAndText(
				this.hoursTicker,
				this.convertTime(Math.floor((diff % this.MILLISECONDS_IN_DAY) / this.MILLISECONDS_IN_HOUR)),
				this.HOURS,
			);
		} else {
			this.setTimeAndText(
				this.hoursTicker,
				this.convertTime(Math.floor(diff / this.MILLISECONDS_IN_HOUR)),
				this.HOURS,
			);
		}

		this.setTimeAndText(
			this.minutesTicker,
			this.convertTime(Math.floor((diff % this.MILLISECONDS_IN_HOUR) / this.MILLISECONDS_IN_MINUTE) + 1),
			this.MINUTES,
		);
		// this.secondsTicker.innerHTML = this.convertTime(
		// 	Math.floor((diff % this.MILLISECONDS_IN_MINUTE) / this.MILLISECONDS_IN_SECOND),
		// ) + this.SECONDS;
	}

	shutDownWholeTimer() {
		clearInterval(this.interval);
		this.preString.innerHTML = '';
		this.daysTicker.innerHTML = '';
		this.hoursTicker.innerHTML = '';
		this.minutesTicker.innerHTML = '';
		// this.secondsTicker.innerHTML = "";
		/*
    Store the height of this element
    Remove the height of this element from the site header
    Remove the height of this element from the announcement
    Remove the height of announcementBar component
    */
		if (this._initialized) {
			const height = this.mainParentContainer.clientHeight;
			const style = this.siteHeader.currentStyle || window.getComputedStyle(this.siteHeader);
			const currentMarginTop = parseInt(style.marginTop);
			this.siteHeader.style.marginTop = currentMarginTop - height + 'px';
			//  restore the init height of the site header
			this.siteHeaderHeight.style.height = this.initHeightOfSiteHeader + 'px';
			this.mainParentContainer.classList.add('hidden');
		}
	}

	updateTimer() {
		const startDate = new Date(this.startDate);
		const firstEndDate = new Date(this.firstIntervalEndDate);
		const secondEndDate = new Date(this.secondIntervalEndDate);
		const currentDate = new Date();
		/*
      First case the start date is in the future
      Second case the start date is in the past and we are in the first interval
      Third case the start date is in the past and we are in the second interval
      Last case the start date is in the past and the second interval is over so clear the interval
    */
		// first case the start date is in the future
		if (startDate > currentDate) {
			const diff = startDate - currentDate;
			this.setTime(this.pre_message, diff);
			return;
		}
		if(!this._initialized && startDate <= currentDate) {
			if (this.mainParentContainer.classList.contains('hidden')) {
				this.mainParentContainer.classList.remove('hidden');
			}
			this.handleSiteHeaderMarginTop();
			this.setAttribute('_initialized', true);
		}
		// second case the start date is in the past and we are in the first interval
		if (currentDate < firstEndDate) {
			const diff = firstEndDate - currentDate;
			this.setTime(this.first_interval_message, diff);
			this._setUrl(this.firstIntervalUrl);
			return;
		}
		// third case the start date is in the past and we are in the second interval
		if (currentDate < secondEndDate) {
			const diff = secondEndDate - currentDate;
			this.setTime(this.second_interval_message, diff);
			this._setUrl(this.secondIntervalUrl);
			return;
		}
		// last case the start date is in the past and the second interval is over so clear the interval
		this.shutDownWholeTimer();
	}
}

if (!customElements.get('count-down')) {
	customElements.define('count-down', CountDown);
}

class CountDownBlock extends HTMLElement {
	MILLISECONDS_IN_DAY = 1000 * 60 * 60 * 24;
	MILLISECONDS_IN_HOUR = 1000 * 60 * 60;
	MILLISECONDS_IN_MINUTE = 1000 * 60;
	MILLISECONDS_IN_SECOND = 1000;
	DAYS = ' Tage';
	HOURS = ' Stunden';
	MINUTES = ' Minuten';
	SECONDS = ' Sekunden';

	FIRST_INTERVAL_STRING = 'DIE BESTEN ANGEBOTE ENDEN IN';
	SECOND_INTERVAL_STRING = 'DER BLACK DEAL ENDET IN';
	constructor() {
		super();
		// return;
		// Start in 20 min and ends in 1 hour
		// Start november 20 2024 16:30:00 and ends november 20 2024 17:30:00
		try {
			this.startDate = this.getAttribute('start-date') || new Date();
			this.countDownResult = this.querySelector('[countdown-result]');
			this.preString = this.querySelector('[pre-string]');
			this.ticker = Array.from(this.querySelectorAll('[ticker-type]'));
			this.firstIntervalUrl = this.getAttribute('url-1');
			this.secondIntervalUrl = this.getAttribute('url-2');
			this.first_interval_message = this.getAttribute('message-1') || this.FIRST_INTERVAL_STRING;
			this.second_interval_message = this.getAttribute('message-2') || this.SECOND_INTERVAL_STRING;
			this.pre_message = this.getAttribute('pre-message') || 'Counter will start in';

			// one hour from now
			this.firstIntervalEndDate = this.getAttribute('end-interval-1') || new Date('2024-11-20T16:30:00');
			this.mainParentContainer = this.closest('.count-down');
			// this.firstIntervalStartDate = ;
			this.secondIntervalEndDate =
				this.getAttribute('end-date') || new Date(this.firstIntervalEndDate.getTime() + 3 * 60 * 1000);

		} catch (error) {
			console.log(error);
		}
	}
	connectedCallback() {
		this.init();
	}

	init() {
		this.setIntervalTimer();
	}

	setIntervalTimer() {
		this.interval = setInterval(() => {
			this.updateTimer();
		}, 1000);
	}

	get daysTicker() {
		return this.ticker.find((ticker) => ticker.getAttribute('ticker-type') === 'days');
	}

	get hoursTicker() {
		return this.ticker.find((ticker) => ticker.getAttribute('ticker-type') === 'hours');
	}

	get minutesTicker() {
		return this.ticker.find((ticker) => ticker.getAttribute('ticker-type') === 'minutes');
	}

	get secondsTicker() {
		return this.ticker.find((ticker) => ticker.getAttribute('ticker-type') === 'seconds');
	}

	get _initialized() {
		return this.getAttribute('_initialized') === 'true';
	}

	convertTime(time) {
		return time.toString().padStart(2, '0');
	}

	setTimeAndText(element, time, text) {
		const daysElement = element.querySelector('.ticker-time');
		const textElement = element.querySelector('.ticker-text');
		daysElement.innerHTML = time;
		textElement.innerHTML = text;
		if (time === '00') {
			daysElement.parentElement.classList.add('hidden');
		}
	}

	shutDownWholeTimer() {
		clearInterval(this.interval);
		this.preString.innerHTML = 'DIE BESTEN ANGEBOTE SIND VORBEI';
		this.daysTicker.innerHTML = '';
		this.hoursTicker.innerHTML = '';
		this.minutesTicker.innerHTML = '';
		// this.secondsTicker.innerHTML = "";
		/*
    Store the height of this element
    Remove the height of this element from the site header
    Remove the height of this element from the announcement
    Remove the height of announcementBar component
    */
		if (this._initialized) {
			this.mainParentContainer.classList.add('hidden');
		}
	}

	setTime(preString, diff) {
		this.preString.innerHTML = preString;

		// this.daysTicker.innerHTML = this.convertTime(Math.floor(diff / this.MILLISECONDS_IN_DAY));
		this.setTimeAndText(this.daysTicker, this.convertTime(Math.floor(diff / this.MILLISECONDS_IN_DAY)), this.DAYS);
		this.setTimeAndText(
			this.hoursTicker,
			this.convertTime(Math.floor((diff % this.MILLISECONDS_IN_DAY) / this.MILLISECONDS_IN_HOUR)),
			this.HOURS,
		);
		this.setTimeAndText(
			this.minutesTicker,
			this.convertTime(Math.floor((diff % this.MILLISECONDS_IN_HOUR) / this.MILLISECONDS_IN_MINUTE) + 1),
			this.MINUTES,
		);
		// this.secondsTicker.innerHTML = this.convertTime(
		// 	Math.floor((diff % this.MILLISECONDS_IN_MINUTE) / this.MILLISECONDS_IN_SECOND),
		// ) + this.SECONDS;
	}

	updateTimer() {
		const startDate = new Date(this.startDate);
		const firstEndDate = new Date(this.firstIntervalEndDate);
		const secondEndDate = new Date(this.secondIntervalEndDate);
		const currentDate = new Date();
		/*
      First case the start date is in the future
      Second case the start date is in the past and we are in the first interval
      Third case the start date is in the past and we are in the second interval
      Last case the start date is in the past and the second interval is over so clear the interval
    */
		// first case the start date is in the future
		if (startDate > currentDate) {
			const diff = startDate - currentDate;
			this.setTime(this.pre_message, diff);
			return;
		}
		if(!this._initialized && startDate <= currentDate) {
			if (this.mainParentContainer.classList.contains('hidden')) {
				this.mainParentContainer.classList.remove('hidden');
			}
			this.setAttribute('_initialized', true);
		}
		// second case the start date is in the past and we are in the first interval
		if (currentDate < firstEndDate) {
			const diff = firstEndDate - currentDate;
			this.setTime(this.first_interval_message, diff);
			this._setUrl(this.firstIntervalUrl);
			return;
		}
		// third case the start date is in the past and we are in the second interval
		if (currentDate < secondEndDate) {
			const diff = secondEndDate - currentDate;
			this.setTime(this.second_interval_message, diff);
			this._setUrl(this.secondIntervalUrl);
			return;
		}
		// last case the start date is in the past and the second interval is over so clear the interval
		this.shutDownWholeTimer();
	}
}

if (!customElements.get('count-down-block')) {
	customElements.define('count-down-block', CountDownBlock);
}
